import { render } from "./BuildingTypeList.vue?vue&type=template&id=680f2fc2&scoped=true"
import script from "./BuildingTypeList.vue?vue&type=script&lang=js"
export * from "./BuildingTypeList.vue?vue&type=script&lang=js"

import "./BuildingTypeList.vue?vue&type=style&index=0&id=680f2fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680f2fc2"]])

export default __exports__